import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import {
  ConceptLinkerValidatorModel,
} from 'models/ConceptLinkerValidatorModel';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import ConceptLinkerValidatorDetails from './ConceptLinkerValidatorDetails';
import ConceptLinkerValidatorCreate from './ConceptLinkerValidatorCreate';
import { Button } from '@material-ui/core';
import { conceptValidatorStatusRenderer } from 'CMFW/grid/cellRenderers/conceptValidatorStatus';
import { IFields } from 'CMFW/grid/fields';

export type IProps = {};

const ConceptLinkerValidator: React.FC = () => {
  const forceRender = useForceRender();
  const [showCreate, setShowCreate] = useState(false);

  const conceptLinkerValidatorModel = useMemo(() => new ConceptLinkerValidatorModel({ render: forceRender }), [
    forceRender,
  ]);

  // Create cell renderers for the list grid
  const cellRenderers = useMemo(
    () => ({
      [IFields.conceptValidatorStatus]: conceptValidatorStatusRenderer,
    }),
    [],
  );

  const handleNewClick = () => {
    setShowCreate(true);
  };

  const handleCreateClose = () => {
    setShowCreate(false);
  };

  const handleCreateSuccess = async (validationId: number) => {
    setShowCreate(false);
    await conceptLinkerValidatorModel.loadItemEdit(validationId);
  };

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={conceptLinkerValidatorModel}>
        <Split widthLeft={432}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button
                variant="outlined"
                onClick={handleNewClick}
                size="small"
              >
                new
              </Button>
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            {showCreate ? (
              <ConceptLinkerValidatorCreate
                model={conceptLinkerValidatorModel}
                onClose={handleCreateClose}
                onSuccess={handleCreateSuccess}
              />
            ) : conceptLinkerValidatorModel.itemId ? (
              <ConceptLinkerValidatorDetails />
            ) : (
              <EmptyState>
                <EmptyStateText>Select a validation from the list or create a new one</EmptyStateText>
              </EmptyState>
            )}
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default ConceptLinkerValidator;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
`;

const EmptyStateText = styled.div`
  text-align: center;
  font-size: 16px;
`;
